import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "@components/shared/Header";
import ErrorBoundary from "@components/shared/ErrorBoundary";
import "@styles/index.css";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { refreshToken } from "@store/thunks/authAction";
import { refreshTokenStudent } from "@store/thunks/studentLogin";
import Cookies from "js-cookie";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useSelector((state) => state.studentAuth);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const checkRefreshToken = async () => {
      try {
        if ( !isAuthenticated) {
          await dispatch(refreshTokenStudent());
        }
      } catch (error) {
        console.error("Refresh token failed:", error.message);
      } finally {
        setAuthChecked(true); // ✅ VERY IMPORTANT
      }
    };

    checkRefreshToken();
  }, [dispatch]);

  // 🚫 BLOCK ROUTER until auth is ready
  if (!authChecked) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
      </div>
    );
  }
  const showHeaderRoutes = ["/unauthorized", "/reviewer", "/forbidden", "/server-error", "*", "/register", "/student", "/TTT", "/my-profile", "/about-sangraha", "/ASR_TTS", "/OCR", "/monolingual-input"];
  const showHeader = showHeaderRoutes.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <ErrorBoundary>
      <div className="font-serif h-screen">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="colored"
        />
        {!showHeader && <Header />}
        <Outlet />
      </div>
    </ErrorBoundary>
  );
}

export default App;
